<template>

  <transition :name="startAnimation ? 'none' : 'slide-fade-up'">
  <div class="post" v-if='loaded'>
    <div class="post__content" :style="{color: post.acf.color_theme}">
        <cmscontent :content="post.content ? post.content.rendered : ''"/>
    </div>
    <NextSlide v-if="nextSlide" :post="nextSlide" next-slide-title="Next machine" show-current="true" :on-start="() => startAnimation = true"/>
    <Footer/>
  </div>
  </transition>
  
</template>

<script>
  import NotFound from '../../components/NotFound/NotFound.vue';
  import Footer from '../../components/Footer/Footer.vue';
  import NextSlide from '../../components/NextSlide/NextSlide.vue';
  import {getUrl} from '../../utils/UrlHelper';

  export default {
    components: {
      NotFound,
      Footer,
      NextSlide,
    },

    mounted: function () {
      this.getCase();
    },

    methods: {
      getCase() {
        this.startAnimation = false;
        this.loaded = false;
        const slug = this.$route.params.slug;
        this.$store.dispatch('getCase', slug).then((data) => {
          if (!data) {
            return this.$router.push('/404');
          }
          this.$store.commit('setTitle', data.title.rendered);
          this.$store.commit('setCurrent', data.id);
          const slide = {
            ...data,
            video: data.acf.video,
            img: data.featured_image_url,
            title: data.title.rendered,
            url: data.link,
            excerpt: data.excerpt.rendered,
            color: data.acf.color_theme || 'white',
            themeColor: data.acf.theme_color || 'white',
            buttonClass: data.acf.button_style,
          };

            this.$store.commit('setHeroAndNavigate', {
              slide,
            });
            if (data.acf.next_slide) {
              this.$store.dispatch('getCaseById', data.acf.next_slide.ID).then((data) => {
                this.nextSlide = {
                  ...data,
                  video: data.acf.video,
                  img: data.featured_image_url,
                  title: data.title.rendered,
                  url: data.link,
                  excerpt: data.excerpt.rendered,
                  color: data.acf.color_theme || 'white',
                  themeColor: data.acf.theme_color || 'white',
                  buttonClass: data.acf.button_style,
                };
              });
            }
          this.post = data;
          this.timer = setTimeout(() => this.loaded = true, 600);
        });
      }
    },

    data() {
      return {
        startAnimation: false,
        loaded: false,
        timer: null,
        nextSlide: null,
        post: {}
      };
    },
    destroyed() {
      clearTimeout(this.timer);
    },
    watch: {
      '$route'(to, from) {
        this.nextSlide = null;
        this.getCase();
      }
    }
  };
</script>

<style lang="scss" >
</style>
